angular.module('pitch.app').controller('LogoutCtrl',
    function($scope, $state, Auth, growl) {

        "use strict";

        Auth.logout().then(function() {
            $state.go('home', {}, { reload: true });
        }, function () {
            $state.go('home', {}, { reload: true });
            growl.error('Something went wrong when logging out');
        });
    }
);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/controllers/LogoutCtrl.js